module.exports = __webpack_public_path__ + "img/new_food.228a1cfa.svg";